export function isTouch(): boolean {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}

export function isMobile(): boolean {
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export function isIOS(): boolean {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export function prefersReducedMotion(): boolean {
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false
}

export function prefersDarkColorScheme(): boolean {
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false
}
